var _path, _path2, _path3, _rect, _path4, _path5, _path6, _path7, _rect2, _rect3, _rect4, _rect5, _path8, _rect6, _rect7, _rect8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGigsly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16H22C27.5228 16 32 20.4772 32 26V26C32 31.5228 27.5228 36 22 36V36C16.4772 36 12 31.5228 12 26V16Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 20C16.5 19.7239 16.7239 19.5 17 19.5H19C19.2761 19.5 19.5 19.7239 19.5 20V21.5H16.5V20Z",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 22C15 21.4477 15.4477 21 16 21H20C20.5523 21 21 21.4477 21 22V24C21 24.5523 20.5523 25 20 25H16C15.4477 25 15 24.5523 15 24V22Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 23,
    width: 6,
    height: 1,
    rx: 0.5,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 23C24 21.8954 24.8954 21 26 21C27.1046 21 28 21.8954 28 23V24H24V23Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26 21V21.5",
    stroke: "white",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 29C18.4477 29 18 29.4477 18 30V31C18 31.5523 18.4477 32 19 32H25C25.5523 32 26 31.5523 26 31V30C26 29.4477 25.5523 29 25 29H19ZM19 30.5C19 30.2239 19.2239 30 19.5 30C19.7761 30 20 30.2239 20 30.5C20 30.7761 19.7761 31 19.5 31C19.2239 31 19 30.7761 19 30.5ZM24 30.5C24 30.2239 24.2239 30 24.5 30C24.7761 30 25 30.2239 25 30.5C25 30.7761 24.7761 31 24.5 31C24.2239 31 24 30.7761 24 30.5Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2957 26.8787C19.3514 26.6561 19.5513 26.5 19.7808 26.5H24.2192C24.4487 26.5 24.6486 26.6561 24.7043 26.8787L25.3596 29.5H18.6404L19.2957 26.8787Z",
    stroke: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 31,
    width: 1,
    height: 2,
    rx: 0.5,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 29,
    width: 1,
    height: 2,
    rx: 0.5,
    transform: "rotate(90 19 29)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 29,
    width: 1,
    height: 2,
    rx: 0.5,
    transform: "rotate(90 27 29)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 31,
    width: 1,
    height: 2,
    rx: 0.5,
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 3C7.44772 3 7 3.44772 7 4V30C7 30.5523 7.44772 31 8 31H13.3378C12.9752 30.3732 12.6787 29.7033 12.4578 29H9V5H29V18.8586C29.8159 19.6584 30.4952 20.5969 31 21.6359V4C31 3.44772 30.5523 3 30 3H8Z",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 10,
    width: 2,
    height: 2,
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 10,
    width: 2,
    height: 2,
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 10,
    width: 2,
    height: 2,
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13 5H25C25 6.10457 24.1046 7 23 7H15C13.8954 7 13 6.10457 13 5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGigsly);
export default __webpack_public_path__ + "static/media/gigsly.1e9651b4e33cd7791aa176620dd6421e.svg";
export { ForwardRef as ReactComponent };